import { useEffect, useState } from 'react';
import { FileUpload } from './components/FileUpload';
import { ImportResult } from './components/ImportResult';
import { AccessDenied } from '../../../../_pages/AccessDenied';
import { ContentSection } from '../../../../components/LayoutElements';
import { Checkbox, Spinner } from '@fluentui/react';
import { useImportTimeEntries } from './hooks/useImportTimeEntries';
import { ImportError } from './components/ImportError';
import { useConfigValuesState } from '../../../../hooks/useConfigValue';

export const JiraUploadSettings = () => {
    const {
        initialData: {
            configuration: { timeEntriesImportEnabled },
        },
        setConfigValue,
    } = useConfigValuesState();
    return (
        <ContentSection>
            <Checkbox
                label="Enable Time Entries Import"
                checked={timeEntriesImportEnabled}
                onChange={(_, checked) => {
                    setConfigValue(config => {
                        return {
                            ...config,
                            enableJiraUpload: Boolean(checked),
                        };
                    });
                }}
            />
            {timeEntriesImportEnabled && <TimeEntriesUpload />}
        </ContentSection>
    );
};

const TimeEntriesUpload = () => {
    const [fileData, setFileData] = useState<File | undefined>(undefined);

    const { mutateImportTimeEntries, isLoadingImportTimeEntries, importErrors, projectumProblem, setProjectumProblem } = useImportTimeEntries();

    useEffect(() => {
        if (!fileData) {
            return;
        }
        mutateImportTimeEntries(fileData);
    }, [fileData, mutateImportTimeEntries]);

    const {
        initialData: {
            aggregatedUser: { originalUser },
        },
    } = useConfigValuesState();

    if (isLoadingImportTimeEntries) {
        return <Spinner label="Import in progress" />;
    }

    if (projectumProblem) {
        return <ImportError problemDetails={projectumProblem} setProblemDetails={setProjectumProblem} setFileData={setFileData}></ImportError>;
    }

    return originalUser.isAdmin ? (
        <>{fileData ? <ImportResult importErrors={importErrors} setFileData={setFileData} /> : <FileUpload setFileData={setFileData} />}</>
    ) : (
        <AccessDenied />
    );
};
